import DATA_SOURCE_TYPES from './data-source-types';

const MAX_MEASUREMENTS_PER_PANEL = 20;

const determinePanelStationMeasurements = (panelProperties, stationList, selectedStations) => {
  const filteredStationList = stationList.filter(f => selectedStations.includes(f.id));

  const formattedData = [];
  for(const panelId in panelProperties){
    const panel = panelProperties[panelId];
    const panelMeasurements = getPanelStationMeasurements(panel, filteredStationList);
    formattedData.push({
      panel_id : panelId,
      sources : panelMeasurements.measurements,
      total_measurements_matched : panelMeasurements.total,
    });
  }
  return formattedData;
}

const FILTER_TYPE_MAPPING = {
  measurement_type : 'subtype_id',
  uom : 'unit_id',
}

const compareFilters = (target, filters) => {
  const results = [];
  for(const filter of filters){
    const mappedType = FILTER_TYPE_MAPPING[filter.type];
    results.push(
      compare(target[mappedType], filter.operator, filter.value)
    );
  }
  return results.every(e => e);
}

const compare = (target, operator, value) => {
  switch(operator){
    case '=':
      return target == value;
    case '!=':
      return target != value;
  }
}
const getPanelStationMeasurements = (panel, stations) => {
  const sourceGroupings = [];
  const alreadyUsedMeasurements = {};
  let total = 0;

  for (const source of panel.data.sources) {
    let grouping = [];
    if(source.type === DATA_SOURCE_TYPES.variableMeasurements.id){
      const matching = stations.reduce((prev, curr, i, arr) => {
        const matchingMeasurementDefs = curr.sensor_definitions.filter(f => compareFilters(f, source.options.filters));

        if(matchingMeasurementDefs.length){
          const stationMeasurements = []

          if (!alreadyUsedMeasurements[curr.id]) {
            alreadyUsedMeasurements[curr.id] = {};
          }

          for (const md of matchingMeasurementDefs) {
            if (!alreadyUsedMeasurements[curr.id][md.name]) {
              total++;
              alreadyUsedMeasurements[curr.id][md.name] = true;
            }

            if (total <= MAX_MEASUREMENTS_PER_PANEL) stationMeasurements.push(md.name);
          }

          prev.push({
            station_id : curr.id,
            measurements : stationMeasurements
          });
        }
        return prev;
      }, []);
      grouping = matching;
    } else if (source.type === DATA_SOURCE_TYPES.exactMeasurement.id) {
      if (!alreadyUsedMeasurements[source.options.station]) {
        alreadyUsedMeasurements[source.options.station] = {};
      }

      if (!alreadyUsedMeasurements[source.options.station][source.options.measurement]) {
        total++;
        alreadyUsedMeasurements[source.options.station][source.options.measurement] = true;
      }

      if (total <= MAX_MEASUREMENTS_PER_PANEL) {
        grouping.push({
          station_id : source.options.station,
          measurements : [source.options.measurement]
        });
      }
    } else { // non-measurement-api data source
      // do nothing
    }
    sourceGroupings.push(grouping);
  }
  return {
    measurements: sourceGroupings,
    total,
  };
}






export default {
  determinePanelStationMeasurements
}